import LabourIcon from '@mui/icons-material/GroupOutlined'
import TripIcon from '@mui/icons-material/MapOutlined'
import ChargesIcon from '@mui/icons-material/ShoppingCartOutlined'
import ProtectionIcon from '@mui/icons-material/HealthAndSafetyOutlined'

import { ChargeCategory } from '../../modules/invoices'

export const categoryIcons = {
  [ChargeCategory.labour]: LabourIcon,
  [ChargeCategory.tripAndTravel]: TripIcon,
  [ChargeCategory.additionalCharges]: ChargesIcon,
  [ChargeCategory.protectiveMaterial]: ProtectionIcon,
}
